import Slider1 from "../assets/img/categoryCard4.jpg"
import Slider2 from "../assets/img/slider-2.png"
import Slider3 from "../assets/img/slider-3.png"

export const SliderData = [
  {
    name: "Chemicals",
    description_md: "Advanced & innovative chemicals for detergent, adhesive, textile & many more industries",
    description: `Our buyer-centric approach is specifically designed to cater to the needs of purchasing managers, R&D professionals, procurement specialists, and manufacturers across multiple industries, including:

 - Textiles & Leather
 - Printing & Packaging
 - Industrial Coatings & Adhesives
 - Personal Care & Detergents
 - Food, Feed And Pharma Grade
 - RO Membrane
 - Agrochemicals
 - Aquaculture
 - Rubber
 - Paint`,
    img: Slider1,
    path: "disinfectant_chemicals"
  },
  // {
  //   name: "Frozen & Chips",
  //   description: "Premium Quality Frozen Food, Chips & More",
  //   img: Slider2,
  //   path: "fish--meat"
  // },
  {
    name: "Powders",
    description: "Premium Quality Food & Herbal Powders",
    img: Slider3,
    path: "fresh-vegetable"
  },
];